import { render, staticRenderFns } from "./CardamomGreenExtract.vue?vue&type=template&id=1031b8eb&scoped=true&"
import script from "./CardamomGreenExtract.vue?vue&type=script&lang=js&"
export * from "./CardamomGreenExtract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1031b8eb",
  null
  
)

export default component.exports